import { render } from "./main.vue?vue&type=template&id=e0cd576a&scoped=true&ts=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=e0cd576a&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0cd576a"]])

export default __exports__